export enum SmartQcTabRoute {
  SUMMARY = 'summary',
  CAMPAIGN = 'campaigns',
  SETTING = 'settings',
  SETTING_CATEGORY = 'settings/category',
  SETTING_KEYWORD = 'settings/keyword',
  SETTING_CRITERIA = 'settings/criteria',
  SETTING_SCRIPT = 'settings/script',
}

export type SmartQCTab = {
  tabRoute: SmartQcTabRoute;
  title: string;
  children?: SmartQCTab[];
};

export const TreeSmartQcTabs: SmartQCTab[] = [
  {
    tabRoute: SmartQcTabRoute.SUMMARY,
    title: 'Tổng quan',
  },
  {
    tabRoute: SmartQcTabRoute.CAMPAIGN,
    title: 'Chiến dịch QC',
  },
  {
    tabRoute: SmartQcTabRoute.SETTING,
    title: 'Cấu hình',
    children: [
      {
        tabRoute: SmartQcTabRoute.SETTING_CATEGORY,
        title: 'Danh mục',
      },
      {
        tabRoute: SmartQcTabRoute.SETTING_KEYWORD,
        title: 'Từ khóa',
      },
      {
        tabRoute: SmartQcTabRoute.SETTING_CRITERIA,
        title: 'Tiêu chí',
      },
      {
        tabRoute: SmartQcTabRoute.SETTING_SCRIPT,
        title: 'Kịch bản',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/smart-qc.const.ts